import { render, staticRenderFns } from "./Favourite.vue?vue&type=template&id=3e49396e&scoped=true"
import script from "./Favourite.vue?vue&type=script&lang=js"
export * from "./Favourite.vue?vue&type=script&lang=js"
import style0 from "./Favourite.vue?vue&type=style&index=0&id=3e49396e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e49396e",
  null
  
)

export default component.exports